// export default ProductMap = {
exports.ProductMap = {
  8: {
    '2 kWh': [{
      name: 'Kit "Starter" (2 kWh)',
      pid: '7773575184610',
      varId: '43013375787234',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4898',
      save_money: '1000',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 2 kWh', '1x Jeu de câbles'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: "Le Kit \"Starter\" vous permet d'installer rapidement un système électrique de base pour votre van/ maison hors réseau à l'aide d'une batterie LFP et d'un Power Hub."
    }, {
      name: 'Kit "Ready"(2 kWh)',
      pid: '7773575184610',
      varId: '43013375820002',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4398',
      old_price: '5468',
      save_money: '1070',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 2 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Sangle de montage de batterie'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'Le Kit "Ready" vous permet de mieux contrôler votre consommation d\'énergie, pour un confort et une commodité accrus lors de vos déplacements ou pour une vie « hors réseau ».'
    }, {
      name: 'Kit "Indépendance" (2 kWh)',
      pid: '7773575184610',
      varId: '43013375852770',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4698',
      old_price: '5798',
      save_money: '1100',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 2 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Console pour Kit Énergie', '1x Sangle de montage de batterie'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'Le Kit "Indépendance" fournit une solution d\'alimentation hors réseau complète. Grâce au panneau de distribution intelligent AC/DC EcoFlow et à la Console pour Kit Énergie, vous pouvez surveiller, contrôler et personnaliser votre alimentation depuis le dispositif mural ou l\'application mobile.'
    }],
    '4 kWh': [{
      name: 'Kit "Starter" (4 kWh)',
      pid: '7773575250146',
      varId: '43013375918306',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5597',
      old_price: '7097',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 2 kWh', '1x Jeu de câbles'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: "Le Kit \"Starter\" vous permet d'installer rapidement un système électrique de base pour votre van/ maison hors réseau à l'aide d'une batterie LFP et d'un Power Hub."
    }, {
      name: 'Kit "Ready"(4 kWh)',
      pid: '7773575250146',
      varId: '43013375951074',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6097',
      old_price: '7667',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 2 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '2x Sangles de montage de batterie'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'Le Kit "Ready" vous permet de mieux contrôler votre consommation d\'énergie, pour un confort et une commodité accrus lors de vos déplacements ou pour une vie « hors réseau ».'
    }, {
      name: 'Kit "Indépendance" (4 kWh)',
      pid: '7773575250146',
      varId: '43013375983842',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '6397',
      old_price: '7997',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 2 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Console pour Kit Énergie', '2x Sangles de montage de batterie'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'Le Kit "Indépendance" fournit une solution d\'alimentation hors réseau complète. Grâce au panneau de distribution intelligent AC/DC EcoFlow et à la Console pour Kit Énergie, vous pouvez surveiller, contrôler et personnaliser votre alimentation depuis le dispositif mural ou l\'application mobile.'
    }],
    '5 kWh': [{
      name: 'Kit "Starter" (5 kWh)',
      pid: '7773575315682',
      varId: '43013376278754',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5998',
      old_price: '7498',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 5 kWh', '1x Jeu de câbles'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: "Le Kit \"Starter\" vous permet d'installer rapidement un système électrique de base pour votre van/ maison hors réseau à l'aide d'une batterie LFP et d'un Power Hub."
    }, {
      name: 'Kit "Ready"(5 kWh)',
      pid: '7773575315682',
      varId: '43013376311522',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6498',
      old_price: '8068',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Sangle de montage de batterie'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'Le Kit "Ready" vous permet de mieux contrôler votre consommation d\'énergie, pour un confort et une commodité accrus lors de vos déplacements ou pour une vie « hors réseau ».'
    }, {
      name: 'Kit "Indépendance" (5 kWh)',
      pid: '7773575315682',
      varId: '43013376344290',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '6798',
      old_price: '8398',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '1x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Console pour Kit Énergie', '1x Sangle de montage de batterie'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'Le Kit "Indépendance" fournit une solution d\'alimentation hors réseau complète. Grâce au panneau de distribution intelligent AC/DC EcoFlow et à la Console pour Kit Énergie, vous pouvez surveiller, contrôler et personnaliser votre alimentation depuis le dispositif mural ou l\'application mobile.'
    }],
    '10 kWh': [{
      name: 'Kit "Starter" (10 kWh)',
      pid: '7773575381218',
      varId: '43013376409826',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9797',
      old_price: '12297',
      save_money: '2500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 5 kWh', '1x Jeu de câbles'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: "Le Kit \"Starter\" vous permet d'installer rapidement un système électrique de base pour votre van/ maison hors réseau à l'aide d'une batterie LFP et d'un Power Hub."
    }, {
      name: 'Kit "Ready"(10 kWh)',
      pid: '7773575381218',
      varId: '43013376442594',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10297',
      old_price: '12867',
      save_money: '2570',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '2x Sangles de montage de batterie'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'Le Kit "Ready" vous permet de mieux contrôler votre consommation d\'énergie, pour un confort et une commodité accrus lors de vos déplacements ou pour une vie « hors réseau ».'
    }, {
      name: 'Kit "Indépendance" (10 kWh)',
      pid: '7773575381218',
      varId: '43013376475362',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '10597',
      old_price: '13197',
      save_money: '2600',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '2x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Console pour Kit Énergie', '2x Sangles de montage de batterie'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'Le Kit "Indépendance" fournit une solution d\'alimentation hors réseau complète. Grâce au panneau de distribution intelligent AC/DC EcoFlow et à la Console pour Kit Énergie, vous pouvez surveiller, contrôler et personnaliser votre alimentation depuis le dispositif mural ou l\'application mobile.'
    }],
    '15 kWh': [{
      name: 'Kit "Starter" (15 kWh)',
      pid: '7773575446754',
      varId: '43013376540898',
      consoleChoose: 'Y',
      off_price: '13596',
      old_price: '17096',
      save_money: '3500',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '3x Batterie LFP 5 kWh', '1x Jeu de câbles'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: "Le Kit \"Starter\" vous permet d'installer rapidement un système électrique de base pour votre van/ maison hors réseau à l'aide d'une batterie LFP et d'un Power Hub."
    }, {
      name: 'Kit "Ready"(15 kWh)',
      pid: '7773575446754',
      varId: '43013376573666',
      consoleChoose: 'Y',
      off_price: '14096',
      old_price: '17666',
      save_money: '3570',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '3x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '3x Sangles de montage de batterie'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'Le Kit "Ready" vous permet de mieux contrôler votre consommation d\'énergie, pour un confort et une commodité accrus lors de vos déplacements ou pour une vie « hors réseau ».'
    }, {
      name: 'Kit "Indépendance" (15 kWh)',
      pid: '7773575446754',
      varId: '43013376606434',
      off_price: '14396',
      old_price: '17996',
      save_money: '3600',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mi-août 2022',
      accessories: ['1x Power Hub', '3x Batterie LFP 5 kWh', '1x Jeu de câbles', '1x Panneau de distribution intelligent AC/DC', '1x Console pour Kit Énergie', '3x Sangles de montage de batterie'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'Le Kit "Indépendance" fournit une solution d\'alimentation hors réseau complète. Grâce au panneau de distribution intelligent AC/DC EcoFlow et à la Console pour Kit Énergie, vous pouvez surveiller, contrôler et personnaliser votre alimentation depuis le dispositif mural ou l\'application mobile.'
    }]
  }
};
exports.solarPanelMap = {
  8: [{
    name: '2*Panneaux Solaires Rigides100W+2*Pieds de montage',
    pid: '7773575545058',
    varId: '43013376737506',
    old_price: '229',
    off_price: '179',
    save_money: '50',
    limit: 99,
    // discount: "%1=369%%2=729%%3=1089%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*Panneau Solaire Rigide 400W+4*Pieds de montage',
    pid: '7773575643362',
    varId: '43013376868578',
    old_price: '799',
    off_price: '599',
    save_money: '200',
    // tips: "*Cet article ne comprend pas la livraison gratuite.",
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*Panneau Solaire Flexible 100W',
    pid: '7773575676130',
    varId: '43013376934114',
    old_price: '149',
    off_price: '129',
    save_money: '20',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }]
};
exports.BatteryMap = {
  8: [{
    name: 'Batterie LFP 2 kWh + Sangles de montage + Câble de batterie',
    pid: '7773575479522',
    varId: '43045022728418',
    off_price: '1748',
    old_price: '2248',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: 'Batterie LFP 5 kWh + Sangles de montage + Câble de batterie',
    pid: '7773575479522',
    varId: '43045023514850',
    off_price: '3848',
    old_price: '4848',
    save_money: '1000',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: 'LFP Batterie 2 kWh',
  //     pid: '7773575479522',
  //     varId: '43013376639202',
  //     off_price: '1699',
  //     old_price: '2199',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'LFP Batterie 5 kWh',
  //     pid: '7773575479522',
  //     varId: '43013376671970',
  //     off_price: '3799',
  //     old_price: '4799',
  //     save_money: '1000',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: 'LFP Batterie 2 kWh + Sangles de montage',
  //     pid: '7773575479522',
  //     varId: '43045022728418',
  //     off_price: '1748',
  //     old_price: '2248',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'LFP Batterie 5 kWh + Sangles de montage',
  //     pid: '7773575479522',
  //     varId: '43045023514850',
  //     off_price: '3848',
  //     old_price: '4848',
  //     save_money: '1000',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     8: {
//         pid: '7773575708898',
//         varId: '43013376966882',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  8: [{
    name: 'Console pour Power Kits EcoFlow',
    pid: '7796105773282',
    varId: '43096347705570',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://fr.ecoflow.com/';